export enum ActionsEnum {
  REGISTER = 1,
  COMPLETE_PROFILE = 2,
}
